import { Module, VuexModule } from "vuex-module-decorators";
import StoreNames from "@/constants/store/StoreNames";

@Module({ namespaced: true, name: StoreNames.App })
export default class AppModule extends VuexModule {
  get websiteVersion(): string {
    return process.env.PACKAGE_VERSION;
  }
}
